import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

// const dummyCardStatusData = [
//     {
//         cardId: "CARD123456",
//         bin: "123456",
//         pan: "411111******1111",
//         status: "Active",
//         enrolled: true,
//         domestic: true,
//         international: false,
//         mccBlocks: [1234, 5678],
//         countryBlocks: ['US', 'CA'],
//         lastSource: "API",
//         updatedAt: "2024-06-01T10:30:00Z",
//         updatedBy: "User1",
//     },
//     {
//         cardId: "CARD654321",
//         bin: "654321",
//         pan: "522222******2222",
//         status: "Hot",
//         enrolled: false,
//         domestic: false,
//         international: true,
//         mccBlocks: [2345, 6789],
//         countryBlocks: ['GB', 'FR'],
//         lastSource: "Manual",
//         updatedAt: "2024-06-02T15:45:00Z",
//         updatedBy: "User2",
//     },
//     {
//         cardId: "CARD789012",
//         bin: "789012",
//         pan: "533333******3333",
//         status: "Warm",
//         enrolled: true,
//         domestic: true,
//         international: true,
//         mccBlocks: [3456, 7890],
//         countryBlocks: ['DE', 'JP'],
//         lastSource: "Batch",
//         updatedAt: "2024-06-03T08:20:00Z",
//         updatedBy: "User3",
//     },
// ];

// const dummyFileImportLogsData = [
//     {
//         auditID: 'AUD-001',
//         timestamp: 'Oct 27, 15:15',
//         user: 'mohsin.ali',
//         action: 'OVERRIDE',
//         entity: 'Card',
//         entityID: 'ACCT-123',
//         changes: 'Status: Active → Hot; MCC Blocks: +6011',
//         ipAddress: '192.168.1.100',
//     },
//     {
//         auditID: 'AUD-002',
//         timestamp: 'Oct 28, 10:30',
//         user: 'jane.doe',
//         action: 'IMPORT',
//         entity: 'Import',
//         entityID: 'ACCT-456',
//         changes: 'Country Blocks: +US, +CA; Enrolled: true → false',
//         ipAddress: '192.168.1.101',
//     },
//     {
//         auditID: 'AUD-003',
//         timestamp: 'Oct 29, 09:45',
//         user: 'john.smith',
//         action: 'UPDATE',
//         entity: 'Card',
//         entityID: 'ACCT-789',
//         changes: 'Status: Warm → Deleted',
//         ipAddress: '192.168.1.102',
//     }
// ]

// const initialState = {
//     cardStatusData: dummyCardStatusData,
//     cardStatusFileImportAuditLogsData: dummyFileImportLogsData,
//     // selectedHistoryDetails: null,
//     pagination: null,
//     loading: false,
//     error: null,
// };

const initialState = {
    cardRegistryData: [],
    cardStatusFileImportAuditLogsData: [],
    pagination: null,
    loading: false,
    error: null,
};

export const getCardRegistry = createAsyncThunk(
    "card-status-management/card-registry",
    async ({ user, pagination, orderBy, search }) => {
        try {
            const { url, endpoint } = user?.routesConfig;
            const { pageSize, currentPage } = pagination;
            // const { sortColumn, isAsce } = orderBy;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.getCardRegistry;

            const apiURL = base + endpointpath + `/${pageSize}/${currentPage}`;
            
            const response = await axiosInstance.post(apiURL, search);
             console.log("apiURL", apiURL);
            if (response?.data?.responseCode === "404") {
                toast.error(response?.data?.responseDescription);
            }

            return response?.data;
        } catch (error) {
            toast.error(error.response?.data?.message);
            throw error.response;
        }
    }
);

export const getAllCardStatusFileImportAuditLogs = createAsyncThunk(
    "card-status/get-all-file-import-logs",
    async ({ user, pagination, orderBy, search }) => {
        try {
            const { url, endpoint } = user?.routesConfig;
            const { pageSize, currentPage } = pagination;
            const { sortColumn, isAsce } = orderBy;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.getAllCardStatusFileImportAuditLogs;

            const apiURL = base + endpointpath + `${pageSize}/${currentPage}/${sortColumn}/${isAsce}`;

            const response = await axiosInstance.post(apiURL, search);

            if (response?.data?.responseCode === '404') {
                toast.error(response?.data?.responseDescription);
            }

            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

// export const getCardStatusByID = createAsyncThunk(
//     "card-status/get-status-by-id",
//     async ({ user, id }) => {
//         try {
//             const { url, endpoint } = user?.routesConfig;

//             const base = url?.acsbackofficemanagement;
//             const endpointpath = endpoint?.acsbackofficemanagement?.getSpecificCardStatus;

//             const apiURL = base + endpointpath + id;

//             const response = await axiosInstance.get(apiURL);

//             if(response?.data?.responseCode === '404') {
//                 toast.error(response?.data?.responseDescription);
//             }

//             return { ...response?.data, status: response.status };
//         } catch (error) {
//             toast.error(error.response.data.message);
//             throw error.response;
//         }
//     }
// );

const cardStatusManagementSlice = createSlice({
    name: "card-status-management",
    initialState,
    reducers: {
        resetSelected: (state) => {
            state.selectedCardStatusDetails = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // GET CARD REGISTRY
            .addCase(getCardRegistry.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCardRegistry.fulfilled, (state, action) => {
                const { data, currentPage, pageSize, totalItem, totalPages } = action?.payload || {};
                state.loading = false;
                state.cardRegistryData = data;
                state.pagination = {
                    currentPage: currentPage || 0,
                    pageSize: pageSize || 20,
                    totalItem,
                    totalPages
                };
            })
            .addCase(getCardRegistry.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error?.message;
            })
            .addCase(getAllCardStatusFileImportAuditLogs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllCardStatusFileImportAuditLogs.fulfilled, (state, action) => {
                const { data, currentPage, pageSize, totalItem, totalPages } = action?.payload || {};
                state.loading = false;
                state.cardStatusFileImportAuditLogsData = data;
                state.pagination = {
                    currentPage: currentPage || 0,
                    pageSize: pageSize || 20,
                    totalItem,
                    totalPages
                };
            })
            .addCase(getAllCardStatusFileImportAuditLogs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    }
});

export const { resetSelected } = cardStatusManagementSlice.actions;

export default cardStatusManagementSlice.reducer;